function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#000000",
    d: "M 53.5,-0.5 C 54.8333,-0.5 56.1667,-0.5 57.5,-0.5C 59.475,0.646381 60.975,2.31305 62,4.5C 62.6667,34.1667 62.6667,63.8333 62,93.5C 61.4015,96.2542 59.9015,98.2542 57.5,99.5C 56.1667,99.5 54.8333,99.5 53.5,99.5C 42.9263,90.4304 32.7596,80.7638 23,70.5C 22.0266,68.6079 21.3599,66.6079 21,64.5C 20.1128,52.7838 20.4462,41.1171 22,29.5C 32.0928,18.9032 42.5928,8.90317 53.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#000000",
    d: "M 6.5,28.5 C 10.5,28.5 14.5,28.5 18.5,28.5C 17.1667,42.5 17.1667,56.5 18.5,70.5C 13.4012,70.8254 8.40118,70.3254 3.5,69C 2.29857,68.0975 1.46524,66.9308 1,65.5C 0.333333,54.8333 0.333333,44.1667 1,33.5C 2.10653,30.887 3.93986,29.2203 6.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.791
    },
    fill: "#000000",
    d: "M 71.5,35.5 C 72.552,35.3505 73.552,35.5172 74.5,36C 77.6667,39.1667 80.8333,42.3333 84,45.5C 87.1667,42.3333 90.3333,39.1667 93.5,36C 97.1114,34.7458 98.6114,35.9124 98,39.5C 94.6507,42.682 91.484,46.0154 88.5,49.5C 91.484,52.9846 94.6507,56.318 98,59.5C 98.2174,62.6572 96.7174,63.8239 93.5,63C 90.3333,59.8333 87.1667,56.6667 84,53.5C 80.8333,56.6667 77.6667,59.8333 74.5,63C 70.9124,63.6114 69.7458,62.1114 71,58.5C 74.0162,55.6511 76.8496,52.6511 79.5,49.5C 76.8496,46.3489 74.0162,43.3489 71,40.5C 70.3603,38.735 70.5269,37.0683 71.5,35.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.2e1bb735e2b6b79bc50a5b7bea31eb60.svg";
export { ForwardRef as ReactComponent };